import { createPopper } from "@popperjs/core";
import { switchScene, findSceneById, findSceneDataById } from "./loadScenes.js";
import { sendEvent } from './events.js';

const linkHotspotIcon = new URL(
  "../SVG/arrow-up-circle-white.svg",
  import.meta.url
);

export function createLinkHotspotElement ( hotspot )
{
  const wrapper = document.createElement( "div" );
  wrapper.classList.add( "hotspot" );
  wrapper.classList.add( "link-hotspot" );
  hotspot.class && wrapper.classList.add( hotspot.class );
  const icon = document.createElement( "img" );
  icon.src = `${ linkHotspotIcon }`;
  icon.classList.add( "link-hotspot-icon" );

  // Set rotation transform.
  const transformProperties = [
    "-ms-transform",
    "-webkit-transform",
    "transform",
  ];
  for ( let i = 0; i < transformProperties.length; i++ )
  {
    const property = transformProperties[ i ];
    icon.style[ property ] = "rotate(" + hotspot.rotation + "rad)";
  }

  wrapper.addEventListener( "click", function ()
  {
    switchScene( findSceneById( hotspot.target ) );
    sendEvent( 'experience', 'changed scene', wrapper.textContent );
  } );

  const tooltip = document.createElement( "div" );
  tooltip.classList.add( "hotspot-tooltip" );
  tooltip.classList.add( "link-hotspot-tooltip" );
  tooltip.innerHTML = findSceneDataById( hotspot.target ).name;
  tooltip.setAttribute( "role", "tooltip" );
  tooltip.setAttribute( "id", "tooltip-LH" );

  const LH_popper = createPopper( icon, tooltip, {
    placement: "top",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [ 0, 5 ],
        },
      },
    ],
  } );

  function show ()
  {
    tooltip.setAttribute( "data-show", "" );
    LH_popper.update();
    sendEvent( 'experience', 'hovered scene button', wrapper.textContent );
  }

  function hide ()
  {
    tooltip.removeAttribute( "data-show" );
  }

  const showEvents = [ "mouseenter", "focus" ];
  const hideEvents = [ "mouseleave", "blur" ];

  showEvents.forEach( ( event ) =>
  {
    wrapper.addEventListener( event, show );
  } );

  hideEvents.forEach( ( event ) =>
  {
    wrapper.addEventListener( event, hide );
  } );

  wrapper.appendChild( icon );
  wrapper.appendChild( tooltip );

  return wrapper;
}
